import type { Achievement, AchievementRefusal } from '@shefira/shared';

import { uiFormat } from './text.js';

/** The chat's line for an achievement just done (ADR 0046). */
export function achievementNotice(achievement: Achievement): string {
  const { name, title } = achievement;
  return title === undefined
    ? uiFormat('Succès accompli : {name}.', { name })
    : uiFormat('Succès accompli : {name}. Nouveau titre : {title}.', { name, title });
}

export const ACHIEVEMENT_REFUSAL_TEXT: Readonly<Record<AchievementRefusal, string>> = {
  invalid: 'Demande invalide.',
  unknown: 'Ce succès n’existe pas.',
  'no-reward': 'Ce succès ne donne pas d’objet.',
  'not-done': 'Ce succès n’est pas encore accompli.',
  claimed: 'Récompense déjà récupérée.',
  'no-title': 'Ce titre n’est pas encore gagné.',
  'bag-full': 'Ton sac est plein : fais de la place pour récupérer la récompense.',
};
